export const accountsSelector = (state) =>
    state.businessTracker?.accounts || [];

export const accountsByTrackerSelector = (trackerKey) => (state) =>
    (state.businessTracker?.accounts || []).filter(
        (a) => a.trackerKey === trackerKey,
    );

export const trackerLoadedSelector = (state) =>
    Boolean(state.businessTracker?.loaded);
